import { ProfileSettingsService } from 'src/app/services/shared/profile-settings/profile-settings.service';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { JobsService } from 'src/app/services/jobs/jobs.service';
import { MatDialog } from '@angular/material/dialog';
import { SocialMediaShareComponent } from '../shared/social-media-share/social-media-share.component';
import { ResumeReferralDetailsComponent } from '../resume-referral/resume-referral-details/resume-referral-details.component';
import { ResumeReferralCopyComponent } from '../resume-referral-copy/resume-referral-copy.component';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterDetails } from 'src/app/classes/job-filter/filter';
import { Options } from 'ng5-slider';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SessionService } from 'src/app/services/session/session.service';
import { RelevantFilterDetails } from '../../classes/job-filter/relabent-jobs-filter';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { MessageService } from '../../services/message/message.service';
import { jsonParse } from '../../app.component';
import { NotificationService } from 'src/app/services/shared/notification/notification.service';
import { environment } from 'src/environments/environment';
import { getIP } from '../jobseeker-registration/services/registration/jobseeker-registration.service';
import { jsonDeepParse } from 'src/app/functions/shared-functions';
import { MatDrawer } from '@angular/material/sidenav';
export const skip = 0;
export const take = 50;
export const relevant_skip = 0;
export const relevant_take = 50;

@Component({
  selector: 'app-my-jobs',
  templateUrl: './my-jobs.component.html',
  styleUrls: ['./my-jobs.component.scss'],
  providers: [JobsService]
})
export class MyJobsComponent implements OnInit {
  masters: any = {};
  comment: any = [];
  filter_details = new FilterDetails();
  relevant_details = new RelevantFilterDetails();
  jobs = [];
  relevant_jobs = [];
  fetch_jobs = 0;
  relevant_jobs_fetch = 0;
  @ViewChild('jobs_section') jobs_section: ElementRef;
  emp_job_apply;
  refer_a_friend;
  share_flag;
  // value: number = 0;
  // highValue: number = 10;
  options: Options = {
    floor: 0,
    ceil: 10
  };
  job_details_display;
  like_flags;
  comment_flags;
  last_scroll_index;
  last_scroll_index_relevant;
  skip;
  take;
  relevant_skip = 0;
  relevant_take = 50;
  take_1 = 50;
  total_count;
  relevant_count;
  user_id;
  flags_card: boolean = false;
  id = 1;
  enable_relevant_jobs;
  enable_jobs;
  @ViewChild('sideNav2', { static: false }) sidebar: MatDrawer;
  filter_form: UntypedFormGroup = new UntypedFormGroup({
    "search": new UntypedFormControl(''),
    "resId": new UntypedFormControl(''),
    "sellerShortCode": new UntypedFormControl(environment.SHORTCODE),
    "expFrom": new UntypedFormControl(0),
    "expTo": new UntypedFormControl(0),
    "jobType": new UntypedFormControl([]),
    "location": new UntypedFormControl([]),
    "currency": new UntypedFormControl(null),
    "minSalary": new UntypedFormControl(0),
    "maxSalary": new UntypedFormControl(0),
    "scale": new UntypedFormControl(5),
    "startPage": new UntypedFormControl(1),
    "limit": new UntypedFormControl(40),
    "myJobs": new UntypedFormControl(1),
  })
  ip_details: any;
  resId: any;
  job_details: any = {};
  portal_details: any;
  default_banner_url: string;
  fetching_jobs: boolean;
  constructor(
    private jobs_service: JobsService,
    public dialog: MatDialog,
    public activated_route: ActivatedRoute,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private change_detect: ChangeDetectorRef,
    private session_service: SessionService,
    private _snackBar: MatSnackBar,
    private notification: NotificationService,
    private message_service: MessageService,
    private profile_settings: ProfileSettingsService,
  ) { }

  comment_form = this.formBuilder.group({
    comment: '',
    req_id: '',
    status_flag: 1
  })


  ngOnInit() {
    this.ip_details = getIP() || {}
    try {
      this.resId = JSON.parse(sessionStorage.getItem('resId')) || 0;
      this.filter_form.controls.resId.patchValue(this.resId)
    }
    catch (err) {

    }
    this.loadMasters(this.ip_details.country)
    if (environment) {
      if (environment.FLAGS['enable_relevant_jobs']) {
        this.enable_relevant_jobs = environment.FLAGS['enable_relevant_jobs'];
      }
      if (environment.FLAGS['enable_jobs']) {
        this.enable_jobs = environment.FLAGS['enable_jobs'];
      }
    }

    this.skip = skip;
    this.take = take;
    this.user_id = 0;
    this.session_service.session.subscribe(res => {
      if (res && res.UserId) {
        this.user_id = res.UserId;
      }
    });
  }

  applyJob(ev) {

  }

  loadMasters(country) {
    this.profile_settings.loadDefaultSettings().subscribe(res => {
      if (res && res['data']) {
        localStorage.setItem('sellerShortCode', res['data'].sellerShortCode)
        this.JobsList(1);
        this.jobs_service.getJobSearchMaster({
          sellerShortCode: res['data'].sellerShortCode,
          countryCode: country
        }).subscribe(res => {
          if (res && res['data']) {
            this.masters = res['data'];
          }
        })
      }
      if (res && res['data'] && res['data'].companySettingsJson) {
        let portal_details = jsonDeepParse(res['data'].companySettingsJson);
        this.portal_details = portal_details;
        // this.preparePortal(this.portal_details);
        if (portal_details && portal_details.banners && portal_details.banners.length) {
          this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
          console.log(this.default_banner_url)
        }
        else {
          this.default_banner_url = 'assets/jobs/wehiring.svg'
        }
        localStorage.setItem('portal_details', JSON.stringify(this.portal_details));
      }
      if (res['data'].careerPortalConfig) {
        let portal_details = jsonDeepParse(res['data'].careerPortalConfig.portalSettings);
        if (portal_details && portal_details.banners && portal_details.banners.length) {
          this.default_banner_url = 'https://storage.googleapis.com/ezeone/icanrefer/' + portal_details.banners[0].cdnPath;
          console.log(this.default_banner_url)
        }
        else {
          this.default_banner_url = 'assets/jobs/wehiring.svg'
        }
      }
    })


  }
  preparePortal(object) {
    if (object) {
      if (object.portalFeviconIcon && object.portalFeviconIcon.length) {
        try {
          let el: any = document.getElementById('appIcon');
          if (el) {
            el.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + object.portalFeviconIcon[0].cdnPath;
          }
        }
        catch (err) {
          console.log(err)
        }
        // this.favIcon.href = 'https://storage.googleapis.com/ezeone/icanrefer/' + this.portal_details.banners[0].cdnPath;
      }
    }
  }

  filter(event, flag, job_flag?) {
    this.skip = 0;
    this.take = 50;
    if (flag == 1 && event.keyCode == 13) {
      this.getPortalListFilter();
    }
    if (flag == 2) {
      this.filterData(job_flag);
    }
  }
  onSelectChange(event: MatTabChangeEvent) {

    if (event.index == 0) {
      this.id = 1;
    } else {
      this.JobsList(2);
    }
  }
  getPortalListFilter() {
    this.JobsList(1);
  }
  JobsList(e) {

    this.id = e;
    this.fetching_jobs = false
    if (e == 1) {
      this.flags_card = false;

      this.jobs_service.saveJobs(this.filter_form.value).subscribe(res => {
        this.fetching_jobs = true;
        if (res['data']) {
          this.total_count = res['data'].count;
          this.fetch_jobs = 1;
          this.jobs = [];
          if (res['data'].list && res['data'].list.length) {
            this.jobs = res['data'].list;
            if (this.jobs && this.jobs.length) {
              for (let i = 0; i < this.jobs.length; i++) {
                if (typeof this.jobs[i].statusHistory == 'string') {
                  try {
                    this.jobs[i].statusHistory = jsonParse(this.jobs[i].statusHistory);
                  }
                  catch (err) {

                    this.jobs[i].statusHistory = []
                  }
                }
                else {
                  this.jobs[i].statusHistory = this.jobs[i].statusHistory;
                }

              }
              this.getJobDetails(this.jobs[0], 1)
            }
          }

        }
      },
        err => {
          if (this.message_service.storage === 401) {
            this._snackBar.open('Unauthorized');
          }
        })
    }
    if (e == 2 && !this.flags_card) {
      this.flags_card = true;
      this.jobs_service.saveJobs(this.filter_form.value).subscribe(res => {
        if (res['data']) {
          if (res['data'].count) {
            this.relevant_count = res['data'].count;
          }
          this.relevant_jobs_fetch = 1;
          this.relevant_jobs = [];
          if (res['data'].relevant_jobs && res['data'].relevant_jobs.length) {
            this.relevant_jobs = res['data'].relevant_jobs;
          }
        }
      },
        err => {
          if (this.message_service.storage === 401) {
            this._snackBar.open('Unauthorized');
          }
        })
    }
  }

  getJobDetails(job, doNotToggle?) {

    this.jobs.forEach(jobs => {
      jobs.active = false;
    })
    job.active = true;

    if (!doNotToggle) {
      if (window.innerWidth < 992) {
        this.sidebar.open();
      }
    }
    this.job_details = jsonDeepParse(job);

    if (this.job_details['keySkills'] && this.job_details['keySkills'] != '') {
      try {
        this.job_details['keySkillsList'] = this.job_details['keySkills'].split(',')

      }
      catch (err) {
        console.log(err)
      }
    }
    if (this.job_details['jobLocation'] && this.job_details['jobLocation'] != '') {
      try {
        this.job_details['prefJobseekerBranch'] = this.job_details['jobLocation'].split(',')

      }
      catch (err) {
        console.log(err)
      }
    }

    // this.jobs_service.getJobs({
    //   productCode: job.productCode
    // }).subscribe((res) => {
    //   this.job_details_display = true;

    //   if (res && res['data']) {
    //     if (res['data']) {
    //       if (res['data'].detail) {
    //         this.job_details = jsonDeepParse(res['data'].detail);
    //         this.job_details['applied'] = job.applied
    //       }
    //       if (res['data'].relevant_jobs && res['data'].relevant_jobs.length) {
    //         this.relevant_jobs = res['data'].relevant_jobs || [];
    //       }
    //     }
    //   }
    // })
  }
  comment_flag = false

  navigateToOnb() {
    this.router.navigate(['my-journey'])
  }
  changecommentPage(flag) {
    this.comment_flag = !this.comment_flag;
  }

  text_area: "number"
  getcomments(code) {
    this.text_area = code
    this.jobs_service.getcomments(code).subscribe((res) => {
      //
      if (res['data']) {
        if (res['data'].Table) {
          this.comment = res['data'].Table;
        }
        //
      }
    })
  }
  ngAfterViewInit() {
    if (this.jobs_section && this.jobs_section.nativeElement && this.jobs_section.nativeElement.innerHTML) {
      this.jobs_section.nativeElement.innerHTML = '<img src="/assets/loader.gif">';
    }
  }
  filterData(e?) {
    if (e == 1) {
      let obj = {};
      obj = this.filter_details;
      obj['skip'] = this.skip;
      obj['take'] = this.take_1;
      this.fetch_jobs = 0;

      this.jobs_service.saveJobs(obj).subscribe((res) => {
        //
        this.jobs = [];
        this.fetch_jobs = 1;
        if (res['data']) {
          if (res['data'].applied_jobs.length) {
            this.jobs = res['data'].applied_jobs;
          }
          if (this.jobs && this.jobs.length) {
            for (let i = 0; i < this.jobs.length; i++) {
              if (typeof this.jobs[i].transaction_history == 'string') {
                this.jobs[i].transaction_history = jsonParse(this.jobs[i].transaction_history);
              }
              else {
                this.jobs[i].transaction_history = this.jobs[i].transaction_history;

              }
            }
          }
        }

        this.jobs = [... this.jobs];
        this.change_detect.detectChanges();

      },
        err => {
          if (this.message_service.storage === 401) {
            this._snackBar.open('Unauthorized');
          }
        })
    }
    if (e == 2) {
      let obj = {};
      obj = this.relevant_details;
      obj['skip'] = this.relevant_skip;
      obj['take'] = this.take_1;
      this.relevant_jobs_fetch = 0;

      this.jobs_service.saveJobs(obj).subscribe((res) => {
        //
        this.relevant_jobs = [];
        this.relevant_jobs_fetch = 1;
        if (res['data']) {
          if (res['data'].relevant_jobs.length) {
            this.relevant_jobs = res['data'].relevant_jobs;
          }
        }
        this.relevant_jobs = [... this.relevant_jobs];
        this.change_detect.detectChanges();

      },
        err => {
          if (this.message_service.storage === 401) {
            this._snackBar.open('Unauthorized');
          }
        })
    }
    // this.filter_details = new FilterDetails();
  }
  socialMediaShare(req_id) {
    if (req_id) {
      const dialogRef = this.dialog.open(SocialMediaShareComponent, {
        width: '450px',
        panelClass: "TM-Dialog",

        data: {
          req_id: req_id || 0
        }
      });

      dialogRef.afterClosed().subscribe(result => {

      });
      // window.open("https://www.facebook.com/dialog/share?app_id=2403562973199584&display=page&href=https%3A%2F%2Fdevelopers.facebook.com%2Fdocs%2F&redirect_uri=https%3A%2F%2Flocalhost%3A4201%2Fhome", '_blank');
      // window.open("https://twitter.com/intent/tweet?text=Hello%20world");
      // window.open('https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=Your+Subject+here&body="MSG"&ui=2&tf=1&pli=1');
      // window.open("https://www.linkedin.com/shareArticle?mini=true&url=http://23.236.49.140:1123&title=LinkedIn%20Developer%20Network&summary=My%20favorite%20developer%20program&source=LinkedIn");
    }
  }
  referAFriend(requirement_id) {
    const dialog = this.dialog.open(ResumeReferralDetailsComponent, {
      width: '400px',
      panelClass: "TM-Dialog",

      disableClose: true,
    });
    dialog.afterClosed().subscribe(result => {


    },
      (reason) => {
        //
      });
    (dialog.componentInstance).requisition_id = requirement_id;
  }
  // applyJob(requirement_id, apply_flag) {
  //   let user = this.session_service.getSession();
  //
  //   if ((!user || !user["UserId"])) {
  //     const dialog = this.dialog.open(LoginComponent, {
  //       width: '500px',
  //       disableClose: true,
  //     });
  //     dialog.afterClosed().subscribe(result => {
  //
  //     });
  //   }
  //   else if (!apply_flag) {
  //     const dialog = this.dialog.open(ResumeReferralCopyComponent, {
  //       width: '400px',
  //       disableClose: true,
  //     });
  //     dialog.afterClosed().subscribe(result => {
  //
  //       if (result) {
  //         this.JobsList();
  //       }
  //     },
  //       (reason) => {
  //         //
  //       });
  //     (dialog.componentInstance).referrer_id = this.activated_route.snapshot.params.user_id;
  //     (dialog.componentInstance).requirement_id = requirement_id;
  //   }
  // }

  withdrawFun(req_res_id, req_id) {
    try {
      this.jobs_service.withdrawApi({ "req_res_id": req_res_id || 0, "req_id": req_id || 0 }).subscribe(res => {
        if (res && res['status']) {
          this.notification.snackbar(res['message'], 'close', 5000);
          window.location.reload();
        }
      })


    }
    catch (err) { }
  }

  savelike(code, like_flag) {
    if (like_flag == 1) {
      like_flag = 0
    } else if (like_flag == 0) {
      like_flag = 1
    }
    let obj = { req_id: code, like_flag: like_flag };
    this.jobs_service.savelike(obj).subscribe(res => {

      if (res["status"] == true) {
        this.jobs_service.saveJobs(this.filter_details).subscribe(res => {
          if (res['data']) {
            if (res['data'].masters) {
              if (res['data'].list && res['data'].list.length) {
                this.jobs = res['data'].list;
              }
            }
          }
        });
      }
    },
      err => {
        if (this.message_service.storage === 401) {
          this._snackBar.open('Unauthorized');
        }
      })

  }

  savebookmark(code, bookmark_flag) {
    if (bookmark_flag == 1) {
      bookmark_flag = 0
    } else if (bookmark_flag == 0) {
      bookmark_flag = 1
    }
    let obj = { req_id: code, bookmark_flag: bookmark_flag };
    this.jobs_service.getbookmark(obj).subscribe(res => {
      if (res["status"] == true) {
        this.jobs_service.saveJobs(this.filter_details).subscribe(res => {

          if (res['data']) {
            if (res['data'].masters) {
              if (res['data'].list && res['data'].list.length) {
                this.jobs = res['data'].list;

              }
            }
          }
        },
          err => {
            if (this.message_service.storage === 401) {
              this._snackBar.open('Unauthorized');
            }
          })
      }
    })


  }

  savecomment(code) {
    let obj = { req_id: code, comment: this.comment_form.value.comment, status_flag: this.comment_form.value.status_flag };
    this.jobs_service.savecomment(obj).subscribe(res => {

      if (res["status"] == true) {
        this.getcomments(code)
        this.jobs_service.saveJobs(this.filter_details).subscribe(res => {
          if (res['data']) {
            if (res['data'].masters) {
              if (res['data'].list && res['data'].list.length) {
                this.jobs = res['data'].list;

              }
            }
          }
        });
      }
    })
    this.comment_form = this.formBuilder.group({
      comment: '',
      req_id: '',
      status_flag: 1
    })


  }
  getNextBatch(e) {
    //
    if (this.id == 1) {
      if (e > 0 && e > this.last_scroll_index) {
        if (e >= this.jobs.length * 0.75) {
          if (this.take <= this.total_count) {
            this.skip = this.take;
            this.take += take;
            let obj = {};
            obj = this.filter_details;
            obj['skip'] = this.skip;
            obj['take'] = this.take_1;
            this.fetch_jobs = 0;
            this.jobs_service.saveJobs(obj).subscribe(res => {
              this.fetch_jobs = 1;
              if (res['data'] && res['data'].applied_jobs) {
                for (let i = 0; i < res['data'].applied_jobs.length; i++) {
                  this.jobs.push(res['data'].applied_jobs[i]);
                }
                if (this.jobs && this.jobs.length) {
                  for (let i = 0; i < this.jobs.length; i++) {
                    if (typeof this.jobs[i].transaction_history == 'string') {
                      this.jobs[i].transaction_history = jsonParse(this.jobs[i].transaction_history);
                    }
                    else {
                      this.jobs[i].transaction_history = this.jobs[i].transaction_history;

                    }
                  }
                }
              }
              this.jobs = [... this.jobs];
              // this.change_detect.detectChanges();

            },
              err => {
                if (this.message_service.storage === 401) {
                  this._snackBar.open('Unauthorized');
                }
              })
          }
        }
      }
      this.last_scroll_index = e;
    }
    if (this.id == 2) {
      if (e > 0 && e > this.last_scroll_index_relevant) {
        if (e >= this.relevant_jobs.length * 0.75) {
          if (this.relevant_take <= this.relevant_count) {
            this.relevant_skip = this.relevant_take;
            this.relevant_take += take;
            let obj = {};
            obj = this.relevant_details;
            obj['skip'] = this.relevant_skip;
            obj['take'] = this.take_1;
            this.relevant_jobs_fetch = 0;
            this.jobs_service.saveJobs(obj).subscribe(res => {
              this.relevant_jobs_fetch = 1;
              if (res['data'] && res['data'].relevant_jobs) {
                for (let i = 0; i < res['data'].relevant_jobs.length; i++) {
                  this.relevant_jobs.push(res['data'].relevant_jobs[i]);
                }
              }
              this.relevant_jobs = [... this.relevant_jobs];
              //this.change_detect.detectChanges();
            },
              err => {
                if (this.message_service.storage === 401) {
                  this._snackBar.open('Unauthorized');
                }
              })
          }
        }
      }
      this.last_scroll_index_relevant = e;
    }
  }
  closeSidebar() {
    this.sidebar.close();
  }
  openNewTabs(job) {
    this.router.navigate(["job-details", 1, 0, job.productCode]);
  }
  reset() {
    this.filter_form.reset()
    this.filter_form.controls.currency.patchValue(2)
    this.filter_form.controls.scale.patchValue(5)
  }
}

export class JobMaster {
  skills = [];
  location = [];
  department = [];
  designation = [];

}
